import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getFichasArquetipo() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("fichasArquetipos/access/listar").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getFichaArquetipo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fichasArquetipos/access/obter", {ID_FICHA_DADOS_ARQUETIPOS: dados.id, componente: dados.componente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getFichasArquetipoBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fichasArquetipos/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCamposFichasArquetipo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fichasArquetipos/access/obterCamposFichaArquetipo", dados).then(({ data }) => {
                        resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};